const FORM_READY_SELECTOR = '[data-tour="perfil-cliente-form-root"][data-carregado="true"]'
const TABLIST_SELECTOR = '[data-tour="perfil-cliente-modulos"] .react-tabs__tab-list'

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }
}

const getModuleDescription = (name) => {
    const normalized = name.toLowerCase()

    if (normalized.includes('ambiental')) {
        return 'Aqui você define o que o perfil poderá acessar no módulo Ambiental.'
    }

    if (normalized.includes('lns')) {
        return 'Aqui você define o que o perfil poderá acessar no módulo LNS.'
    }

    if (normalized.includes('base')) {
        return 'Aqui você define o acesso às funcionalidades da plataforma principal.'
    }

    return `Aqui você define o que o perfil poderá acessar no módulo ${name}.`
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const isFormularioPreenchido = () => {
    const root = document.querySelector('[data-tour="perfil-cliente-form-root"]')
    return root?.getAttribute('data-form-preenchido') === 'true'
}

const AVISO_SALVAR_PERFIL =
    'Os dados preenchidos durante o tour serão <b>salvos</b> como um novo perfil de cliente.'

const salvarPerfil = () => {
    document.querySelector('[data-tour="perfil-cliente-salvar"]')?.click()
}

const aguardarAvisoDeSucesso = (tourManager) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body')

        if (body && /sucesso/i.test(body.textContent || '')) return body

        return null
    }, 8000)

const bindIrParaClienteLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-cliente]'
        )

        if (!link || link._hdvIrClienteBound) return

        link._hdvIrClienteBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            tourManager.finish('perfil-cliente-pos-salvar')
            tourManager.history?.push('/cliente')
        })
    }, 0)
}

const buildPerfilClientePosSalvarTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Tudo pronto!',
            description: 'O perfil foi salvo com sucesso. Agora você pode <a href="#" class="hdv-tour-start-link" data-hdv-ir-cliente>vincular este perfil a um cliente</a>.',
            onDoneClick: () => tourManager.finish('perfil-cliente-pos-salvar'),
        },
        onHighlighted: () => bindIrParaClienteLink(tourManager),
    },
]

const salvarPerfilEMostrarProximosPassos = (tourManager) => {
    salvarPerfil()

    aguardarAvisoDeSucesso(tourManager)
        .then(() => {
            document.querySelector('.modal.show .modal-footer .hdv-btn-blue')?.click()

            return tourManager.waitForElement('[data-tour="perfil-cliente-lista"]')
        })
        .then(() => {
            tourManager.start('perfil-cliente-pos-salvar', { resumeIndex: 0 })
        })
        .catch(() => {})
}

const concluirTour = (tourManager) => () => {
    tourManager.finish('perfil-cliente-form')

    if (!isFormularioPreenchido()) return

    mostrarAviso(AVISO_SALVAR_PERFIL, {
        callback: () => salvarPerfilEMostrarProximosPassos(tourManager),
        callbackLabelClose: 'Cancelar',
    })
}

const buildPerfilClienteFormTourSteps = (tourManager) => {
    const moduleTabs = Array.from(document.querySelectorAll('[data-tour^="perfil-cliente-tab-"]'))
    const multiplosModulos = moduleTabs.length > 1

    const steps = [
        {
            element: '[data-tour="perfil-cliente-nome"]',
            ensureReady: () => tourManager.waitForElement(FORM_READY_SELECTOR),
            popover: {
                title: 'Nome do perfil',
                description: 'Dê um nome que ajude a identificar este conjunto de permissões. O mesmo perfil pode ser usado por vários clientes.',
                side: 'bottom',
                align: 'start',
            },
        },
    ]

    if (multiplosModulos) {
        steps.push({
            element: TABLIST_SELECTOR,
            popover: {
                title: 'Permissões por módulo',
                description: 'As permissões são separadas por módulos. Em cada aba, escolha quais funcionalidades o cliente poderá utilizar.',
                side: 'bottom',
                align: 'start',
            },
        })

        moduleTabs.forEach((tab) => {
            const selector = `[data-tour="${tab.getAttribute('data-tour')}"]`
            const name = (tab.textContent || '').trim()

            steps.push({
                element: selector,
                popover: {
                    title: `Módulo ${name}`,
                    description: getModuleDescription(name),
                    side: 'bottom',
                    align: 'start',
                },
                onHighlighted: () => clickTab(selector),
            })
        })
    }

    steps.push(
        {
            element: '[data-tour="perfil-cliente-grupo"]',
            popover: {
                title: 'Funcionalidades',
                description: 'Cada bloco representa uma funcionalidade do sistema e reúne as ações disponíveis para ela.',
                side: 'top',
                align: 'start',
            },
            onHighlighted: () => {
                if (moduleTabs.length > 0) {
                    clickTab(`[data-tour="${moduleTabs[0].getAttribute('data-tour')}"]`)
                }
            },
        },
        {
            element: '[data-tour="perfil-cliente-marcar-grupo"]',
            popover: {
                title: 'Selecionar o grupo',
                description: 'Use esta opção para permitir ou revogar todas as ações desta funcionalidade de uma só vez.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="perfil-cliente-permissao"]',
            popover: {
                title: 'Permissões individuais',
                description: 'Marque somente as ações que o perfil poderá realizar, como visualizar, adicionar, editar ou excluir. O que ficar desmarcado não será permitido.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="perfil-cliente-salvar"]',
            popover: {
                title: 'Salvar perfil',
                description: 'Depois de definir o nome e as permissões, salve o perfil. Ele ficará disponível para uso no cadastro de clientes.',
                side: 'top',
                align: 'start',
            },
        },
        {
            popover: {
                title: 'Tudo pronto!',
                description: 'O perfil funciona como um conjunto pronto de permissões e pode ser usado por mais de um cliente. Ao cadastrar um cliente, será obrigatório escolher um perfil para definir o acesso dele ao sistema e ao aplicativo.',
                onDoneClick: concluirTour(tourManager),
            },
        }
    )

    return steps
}

const buildNovoPerfilClienteTourSteps = (tourManager) => {
    if (/\/perfil\/cliente\/(novo|\d+\/editar)/.test(window.location.pathname)) {
        setTimeout(() => {
            tourManager.handoff('novo-perfil-cliente', 'perfil-cliente-form', FORM_READY_SELECTOR)
        }, 0)

        return [
            {
                popover: {
                    title: 'Perfis de cliente',
                    description: 'Carregando o cadastro do perfil...',
                },
            },
        ]
    }

    let handoffEditarPerfilHandler = null

    const unbindHandoffAoEditarPerfil = () => {
        if (!handoffEditarPerfilHandler) return

        document.removeEventListener('click', handoffEditarPerfilHandler, true)
        handoffEditarPerfilHandler = null
    }

    const bindHandoffAoEditarPerfil = () => {
        if (handoffEditarPerfilHandler) return

        handoffEditarPerfilHandler = (event) => {
            if (event.target.closest('input[type="checkbox"]')) return

            setTimeout(() => {
                if (!/\/perfil\/cliente\/\d+\/editar/.test(window.location.pathname)) return
                if (tourManager.activeTourName !== 'novo-perfil-cliente') return

                unbindHandoffAoEditarPerfil()
                tourManager.handoff('novo-perfil-cliente', 'perfil-cliente-form', FORM_READY_SELECTOR)
            }, 100)
        }

        document.addEventListener('click', handoffEditarPerfilHandler, true)
    }

    const iniciarCadastro = () => {
        unbindHandoffAoEditarPerfil()

        tourManager.navigateAndWait('/perfil/cliente/novo', '[data-tour="help-perfil-cliente-form"]', 0)
            .then(() => {
                tourManager.handoff(
                    'novo-perfil-cliente',
                    'perfil-cliente-form',
                    FORM_READY_SELECTOR
                )
            })
            .catch(() => {})
    }

    const hasPerfisNaLista = () =>
        document.querySelectorAll('[data-tour="perfil-cliente-lista"] tbody tr').length > 0

    const steps = [
        {
            popover: {
                title: 'Perfis de cliente',
                description: 'Antes de cadastrar um cliente, crie um perfil para definir o que ele poderá visualizar e fazer no sistema e no aplicativo.',
            },
            onHighlighted: () => bindHandoffAoEditarPerfil(),
        },
    ]

    if (hasPerfisNaLista()) {
        steps.push({
            element: '[data-tour="perfil-cliente-lista"]',
            popover: {
                title: 'Perfis cadastrados',
                description: 'Estes são os perfis já cadastrados. Qualquer um deles pode ser vinculado a um cliente no momento do cadastro ou da edição.',
                side: 'top',
                align: 'start',
            },
            onHighlighted: () => bindHandoffAoEditarPerfil(),
        })
    }

    steps.push({
        element: '[data-tour="perfil-cliente-novo"]',
        popover: {
            title: 'Novo perfil',
            description: 'Clique em <strong>Concluir</strong> para iniciar um novo perfil de cliente.',
            side: 'bottom',
            align: 'start',
            onNextClick: iniciarCadastro,
            onDoneClick: iniciarCadastro,
        },
        onHighlighted: () => bindHandoffAoEditarPerfil(),
    })

    tourManager.setTourCleanup?.(() => unbindHandoffAoEditarPerfil())

    return steps
}

export { buildPerfilClienteFormTourSteps, buildPerfilClientePosSalvarTourSteps }
export default buildNovoPerfilClienteTourSteps
